import { render, staticRenderFns } from "./DocumentsTab.vue?vue&type=template&id=d96464ce&scoped=true"
import script from "./DocumentsTab.vue?vue&type=script&lang=js"
export * from "./DocumentsTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d96464ce",
  null
  
)

export default component.exports